
enum ValidationErrorLevel {
  CRITICAL = 'CRITICAL',
  WARN = 'WARN',
  INFO = 'INFO',
}

export default ValidationErrorLevel;
